import * as React from "react";
import {CSSProperties} from "react";
import {Box, Paper} from "@mui/material";
import PageCommands, {PageCommandProps} from "./PageCommands";

export type PageContentProps = {
   fullHeight?: boolean
   style?: CSSProperties | undefined
   children?: React.ReactNode | React.ReactNode[];
   commands?: React.ReactNode | React.ReactNode[];
   noPadding?: boolean
   noBorder?: boolean
   commandProps?: PageCommandProps
}

const PageContent = ({fullHeight, style, children, commands, noPadding, commandProps, noBorder}: PageContentProps) => {
   let minHeight = 'initial';
   if (fullHeight) {
      minHeight = 'calc(100vh - 140px)'
   }
   return <Paper variant={"outlined"} sx={{
      width: '100%',
      height: '100%',
      borderRadius: '8px',
      minHeight: minHeight,
      marginBottom: '10px !important',
      border: noBorder ? 'none' : undefined,
      position: 'relative'
   }} >
      {commands && <PageCommands {...commandProps}>{commands}</PageCommands>}
      <Box sx={{
         marginTop: '-2px',
         padding: noPadding ? '0' : '15px 25px 15px 25px',
         ...style
      }}>
         {children}
      </Box>
   </Paper>
}

export default PageContent